import React from 'react'
import styled from 'styled-components'

import { BackGroundGradientProps } from './'

/**
 * SAFIC用グラデーション背景
 */
const SaficBackground: React.FC<BackGroundGradientProps> = (props) => {
  return <StyledSaficBackground {...props} />
}

export const StyledSaficBackground = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  min-height: 100%;
  margin: 0;
  background: var(--color-main-gradient-start);
  background: linear-gradient(
    347deg,
    var(--color-main-gradient-start),
    var(--color-main-gradient-end)
  );
`

export default SaficBackground
